import { memo, type MouseEvent } from "react";
import type { InventoryItem, SlotLocation } from "../types";
import { locationsEqual } from "../utils/location";
import { SectionLabel } from "./SectionLabel";
import { ItemSlot } from "./ItemSlot";
import fastItemsIcon from "../assets/images/fast-items-icon.webp";

interface Props {
  items: (InventoryItem | null)[];
  selectedLocation?: SlotLocation | null;
  onItemClick: (item: InventoryItem, location?: SlotLocation) => void;
  onItemRightClick: (
    e: MouseEvent,
    item: InventoryItem,
    location?: SlotLocation,
  ) => void;
  className?: string;
}

export const FastItems = memo(function FastItems({
  items,
  selectedLocation,
  onItemClick,
  onItemRightClick,
  className = "",
}: Props) {
  return (
    <div className={`flex flex-col gap-2 flex-shrink-0 ${className}`}>
      <SectionLabel
        icon={fastItemsIcon}
        title="Fast items"
        //  subtitle="here you keeping your stuff"
      />

      <div className="flex flex-col gap-1">
        <div
          className="grid gap-1"
          style={{
            gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))`,
          }}
        >
          {items.map((item, i) => {
            const loc: SlotLocation = { section: "fastItems", index: i };
            return (
              <div key={i} className="aspect-square">
                <ItemSlot
                  item={item}
                  location={loc}
                  isActive={
                    !!selectedLocation && locationsEqual(selectedLocation, loc)
                  }
                  compact
                  onClick={onItemClick}
                  onRightClick={onItemRightClick}
                />
              </div>
            );
          })}
        </div>

        <div
          className="grid gap-1"
          style={{
            gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))`,
          }}
        >
          {items.map((_, i) => (
            <div
              key={i}
              className="flex items-center justify-end"
              data-slot="keybind-badge"
            >
              <span className="text-[13px] 2560px:text-[16px] font-[400] max-w-fit text-white bg-[#137FE3] rounded-[4px] min-w-[18px] min-h-[18px] 2560px:min-w-[22px] 2560px:min-h-[22px] text-center">
                {i + 1}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});
